const carouselModal = document.querySelector('.category-carousel__modal');
const carouselSlides = document.querySelectorAll('[id^="video-slide--"]');
const modalContent = document.querySelector('.category-carousel__modal .modal--content');
const modalVideo = document.querySelector('.category-carousel__modal .modal--content video');
const sourceElement = document.querySelector('.category-carousel__modal .modal--content video source');
const closeModal = document.querySelector('.category-carousel__modal .modal--content .modal--close');

carouselSlides.forEach((slide) => {
    slide.addEventListener('click', (e) => {
        let slideTarget = e.currentTarget;
        let videoData = JSON.parse(slideTarget.dataset.video);
        console.log(videoData.sources);
        let videoUrl = videoData.sources[0].url
        carouselModal.setAttribute('open' , '');
        sourceElement.setAttribute('src', videoUrl);
        modalVideo.load();
    });
});


closeModal.addEventListener('click', () => {
    carouselModal.removeAttribute('open');
    modalVideo.pause();
})

carouselModal.addEventListener('click', (e) => {
    if (e.target === carouselModal) {
        carouselModal.removeAttribute('open');
        modalVideo.pause();
    }
});

modalContent.addEventListener('click', (e) => {
    e.stopPropagation();
});